"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "../../icons/index.js";
import makeStyles from "../../theming/make-styles.js";
import { IconButton } from "../button/index.js";
import PaginationItem from "./pagination-item.js";
import usePagination from "./use-pagination.js";
const useStyles = makeStyles()((theme, { gap, labelPosition = "left" }) => {
    const wrapperPosition = {
        left: "max-content 0fr 0fr",
        center: "0fr max-content 0fr",
        right: "0fr 0fr max-content",
    };
    const position = {
        left: "1 / 1",
        center: "2 / 2",
        right: "3 / 3",
    };
    return {
        wrapper: {
            display: "grid",
            columnGap: theme.spacing(gap),
            gridTemplateColumns: wrapperPosition[labelPosition],
            alignItems: "center",
        },
        label: Object.assign(Object.assign({}, theme.typography.small), { display: "flex", gap: theme.spacing(gap), gridColumn: position[labelPosition], gridRow: "1 / 1", alignItems: "center" }),
    };
});
export function DefaultLabel(_a) {
    var { color, count, round, size, skip, total, variant, onChange } = _a, props = __rest(_a, ["color", "count", "round", "size", "skip", "total", "variant", "onChange"]);
    const range = usePagination({ count, skip, total });
    return (_jsx(_Fragment, { children: range === null || range === void 0 ? void 0 : range.map((page, i) => {
            if (page === "...") {
                return (_jsx(PaginationItem, { color: color, disabled: true, round: round, size: size, variant: "link", children: "\u2026" }, i));
            }
            return (_jsx(PaginationItem, Object.assign({ active: page === skip / count, color: color, round: round, size: size, variant: variant, onClick: () => onChange(+page * count, count) }, props, { children: +page + 1 }), i));
        }) }));
}
export const DefaultPrevButton = React.forwardRef(function DefaultPrevButton(_a, ref) {
    var { color, round, size, variant } = _a, props = __rest(_a, ["color", "round", "size", "variant"]);
    return _jsx(IconButton, Object.assign({ ref: ref, color: color, icon: ChevronLeftIcon, round: round, size: size, variant: variant }, props));
});
export const DefaultNextButton = React.forwardRef(function DefaultNextButton(_a, ref) {
    var { color, round, size, variant } = _a, props = __rest(_a, ["color", "round", "size", "variant"]);
    return _jsx(IconButton, Object.assign({ ref: ref, color: color, icon: ChevronRightIcon, round: round, size: size, variant: variant }, props));
});
export function Pagination(_a) {
    var { className, color = "primary", count = 20, gap = "sm", label = DefaultLabel, labelPosition = "center", nextButton: NextButton = DefaultNextButton, prevButton: PrevButton = DefaultPrevButton, round = true, size = "small", skip = 0, total, variant = "link", onChange } = _a, props = __rest(_a, ["className", "color", "count", "gap", "label", "labelPosition", "nextButton", "prevButton", "round", "size", "skip", "total", "variant", "onChange"]);
    const { classes, cx } = useStyles({ gap, labelPosition });
    return (_jsxs("div", Object.assign({ className: cx(classes.wrapper, className), "data-component": "pagination" }, props, { children: [_jsx("div", { className: classes.label, children: React.createElement(label, { color, count, round, size, skip, total, variant, onChange }) }), _jsx(PrevButton, { color: color, disabled: skip <= 0, round: round, size: size, variant: variant, onClick: () => onChange(Math.max(skip - count, 0), count) }), _jsx(NextButton, { color: color, disabled: skip + count >= total, round: round, size: size, variant: variant, onClick: () => onChange(skip + count, count) })] })));
}
export default Pagination;
//# sourceMappingURL=pagination.js.map